import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Typography, Divider, Button } from "@material-ui/core";
import useMediaQuery from "@mui/material/useMediaQuery";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MuiButton from "@mui/material/Button";
import defaultimg from "../../assets/images/default.png";
import VegIcon from "../../assets/images/Veg Icon 1.svg";
import NonVegIcon from "../../assets/images/Non Veg Icon 1.svg";
import BasketIcon from "../../assets/images/basket.svg";
import dineInIcon from "../../assets/images/DI.svg";
import takeAwayIcon from "../../assets/images/TA.svg";
import { BUTTON_COLOR, TEXT_COLOR } from "../../utils/constant";
import { store } from "../../index";
import { executeCalculationEngine, download_invoice } from "../../utils/order_helper";

const formatOrderDate = (dateString) => {
  if (!dateString) return "";
  
  // Try parsing ISO format directly to avoid timezone conversions
  const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/);
  if (match) {
    const year = parseInt(match[1], 10);
    const monthIndex = parseInt(match[2], 10) - 1;
    const day = parseInt(match[3], 10);
    let hours = parseInt(match[4], 10);
    const minutes = match[5].padStart(2, "0");
    
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[monthIndex];
    
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
  }

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";
  const day = date.getDate();
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12;
  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
};

const getStatusActionArea = (order, primaryColor, secondaryColor, BUTTON_COLOR, TEXT_COLOR, handleReorderButton, storeInfoConfig) => {
  const sessionState = store.getState().sessionReducer || {};
  let isTableMgmt = sessionState.is_fsr === true;
  const orderStatus = (order?.order_status || "").toUpperCase();
  const orderState = (order?.order_state || "").toUpperCase();
  
  const isFSRClosed = isTableMgmt && (orderStatus === "CLOSE" || orderStatus === "CLOSED" || orderState === "CLOSE" || orderState === "CLOSED");
  const isNormalClosed = orderStatus === "COMPLETED" || orderStatus === "COMPLETE" || orderState === "COMPLETED" || orderState === "COMPLETE";
  const activeBgColor = primaryColor || BUTTON_COLOR;
  const activeTextColor = secondaryColor || TEXT_COLOR;
  
  const commonStyle = {
    width: "110px",
    height: "36px",
    borderRadius: "5px",
    fontWeight: "700",
    fontSize: "13px",
    fontFamily: "Satoshi",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };
  
// Adding this check to determine if the order is from a previous date, which allows reordering even if the status is not COMPLETED or CLOSE. This is based on the assumption that orders from previous dates should be reorderable regardless of their current status.
  const orderDateStr = order?.business_date || order?.date_time || order?.created_at;
  const businessDateStr = sessionState?.store_details?.business_date;
  
  let isPreviousDate = false;
  if (businessDateStr && orderDateStr) {
    const bDate = businessDateStr.slice(0, 10);
    const oDate = orderDateStr.replace(" ", "T").slice(0, 10);
    isPreviousDate = bDate !== oDate;
  } else {
    isPreviousDate = orderDateStr && new Date(orderDateStr).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
  }

  const isMenuOnly = storeInfoConfig?.web_ordering_setting?.is_menu || sessionState?.store_config?.web_ordering_setting?.is_menu;

  if (isPreviousDate || isNormalClosed || isFSRClosed) {
    if (isTableMgmt) {
      return null;
    }
    if (isMenuOnly) {
      return (
        <div
          style={{
            ...commonStyle,
            backgroundColor: activeBgColor,
            color: "white",
            cursor: "default",
            userSelect: "none",
          }}
        >
          {isNormalClosed || isFSRClosed ? "Completed" : "Closed"}
        </div>
      );
    }
    return (
      <Button
        onClick={() => handleReorderButton(order)}
        variant="contained"
        style={{
          ...commonStyle,
          backgroundColor: activeBgColor,
          color: "white",
          textTransform: "none",
          boxShadow: "none",
          padding: 0,
        }}
      >
        <img
          src={require("../../assets/images/Reorder.svg").default || require("../../assets/images/Reorder.svg")}
          style={{ width: "12px", height: "12px", marginRight: "6px" }}
          alt=""
        />
        Reorder
      </Button>
    );
  } else if (orderStatus === "CANCELLED" || orderState === "CANCELLED") {
    return (
      <div
        style={{
          ...commonStyle,
          backgroundColor: "#FEE2E2",
          color: "#EF4444",
        }}
      >
        Cancelled
      </div>
    );
  } else if (orderStatus === "READY" || orderState === "READY") {
    return (
      <div
        style={{
          ...commonStyle,
          backgroundColor: activeBgColor,
          color: activeTextColor,
        }}
      >
        <div
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: "white",
            marginRight: "6px",
          }}
        />
        Ready
      </div>
    );
  } else if (orderStatus === "PLACED" || orderState === "PLACED") {
    return (
      <div
        style={{
          ...commonStyle,
          backgroundColor: activeBgColor,
          color: activeTextColor,
        }}
      >
        <img
          className="preparing-blink"
          src={require("../../assets/images/Preparing.svg").default || require("../../assets/images/Preparing.svg")}
          style={{ width: "16px", height: "16px", marginRight: "6px" }}
          alt=""
        />
        Placed
      </div>
    );
  } else {
    // Placed, Preparing, Open, Hold, In Progress
    return (
      <div
        style={{
          ...commonStyle,
          backgroundColor: activeBgColor,
          color: activeTextColor,
        }}
      >
        <img
          className="preparing-blink"
          src={require("../../assets/images/Preparing.svg").default || require("../../assets/images/Preparing.svg")}
          style={{ width: "16px", height: "16px", marginRight: "6px" }}
          alt=""
        />
        Preparing
      </div>
    );
  }
};

const getDietaryIcon = (e, itemVerriantList) => {
  let dietary = (e?.dietary || "").toLowerCase().trim();
  if (!dietary && itemVerriantList) {
    const item = itemVerriantList.find(
      (iv) => iv.sku === e?.sku || iv.item_variant?.[0]?.sku === e?.sku
    );
    if (item?.dietary) {
      dietary = item.dietary.toLowerCase().trim();
    }
  }
  if (dietary === "veg") {
    return VegIcon;
  }
  if (dietary === "non-veg" || dietary === "nonveg" || dietary === "non veg") {
    return NonVegIcon;
  }
  return null;
};

const groupItems = (items) => {
  if (!items?.length) return [];
  const subs = items.filter(i => i.main_item_id);
  return items.filter(i => !i.main_item_id || !items.some(p => [String(p._id), String(p.item_id), String(p.sku)].includes(String(i.main_item_id))))
    .map(p => ({ ...p, subItems: subs.filter(s => [String(p._id), String(p.item_id), String(p.sku)].includes(String(s.main_item_id))) }));
};

export default function PreviousOrder(props) {
  const navigate = useNavigate();
  const { reducer, currency, itemVerriantList, storeInfo, customer, searchQuery, cartProps } = props;
  const storeInfoConfig = props.storeInfoConfig || props.sessionReducer?.store_config;
  const [expandedOrders, setExpandedOrders] = useState({});
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [pendingOrder, setPendingOrder] = useState(null);
  const [selectedOrderDetail, setSelectedOrderDetail] = useState(() => {
    const saved = sessionStorage.getItem("SELECTED_ORDER_DETAIL");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error(e);
      }
    }
    return null;
  });

  const openOrderDetail = (order) => {
    setSelectedOrderDetail(order);
    if (order) {
      sessionStorage.setItem("SELECTED_ORDER_DETAIL", JSON.stringify(order));
    } else {
      sessionStorage.removeItem("SELECTED_ORDER_DETAIL");
    }
  };
  const stores = props.sessionReducer?.associated_stores;
  let { last_order } = reducer;

  let primaryColor = props.sessionReducer?.store_config?.general_config?.primary_color;
  let secondaryColor = props.sessionReducer?.store_config?.general_config?.secondary_color;
  const isMenuOnly = props.sessionReducer?.store_config?.web_ordering_setting?.is_menu === true;

  const handleReorderButton = (order) => {
    const single_outlet = props.sessionReducer?.store_config?.web_ordering_setting?.single_outlet_per_session;
    const addedItems = cartProps?.addedItems || [];
    const currentCartStoreId = addedItems?.[0]?.store_id;
    const orderStoreId = order?.store_details?.store_id || order?.store_id;

    if (single_outlet && currentCartStoreId && String(currentCartStoreId) !== String(orderStoreId)) {
      setPendingOrder(order);
      setConfirmPopup(true);
    } else {
      executeReorder(order);
    }
  };

  const executeReorder = (order) => {
    const store_id = order?.store_details?.store_id || order?.store_id;
    const targetStore = stores?.find((s) => s.store_id === store_id);
    if (targetStore) {
      props.set_filters({ ...props.filterReducer, selected_store: targetStore, category: "" });
    }

    const groupedOrderItems = groupItems(order.item_details || []);

    groupedOrderItems.forEach((_e) => {
      const foundItem = itemVerriantList.find((e) => _e?.sku === e?.item_variant[0].sku);
      if (foundItem) {
        const item = JSON.parse(JSON.stringify(foundItem));
        if (_e.subItems && _e.subItems.length > 0) {
            item.selected_addons_items = _e.subItems.map(subItem => {
                const subFound = itemVerriantList.find(e => subItem.sku === e?.item_variant[0].sku);
                return subFound ? JSON.parse(JSON.stringify(subFound)) : null;
            }).filter(Boolean);
        }
        props.addToCart(item, _e.quantity || 1);
      }
    });
    navigate("/cart");
  };

  const confirmReorderSwitch = () => {
    setConfirmPopup(false);
    props.clearCart();
    if (pendingOrder) {
      executeReorder(pendingOrder);
      setPendingOrder(null);
    }
  };

  const handleViewMenu = (ele) => {
    const store_id = ele?.store_details?.store_id || ele?.store_id;
    const targetStore = stores?.find((s) => s.store_id === store_id);
    if (targetStore) {
      props.set_filters({ ...props.filterReducer, selected_store: targetStore, category: "" });
    }
    navigate("/menu");
  };

  const isMultiStore = props.sessionReducer?.store_config?.web_ordering_setting?.is_multi_store_qr;
  const allowedStoreIds = new Set();
  if (isMultiStore && Array.isArray(stores) && stores.length > 0) {
    stores.forEach(s => {
      if (s?.store_id) allowedStoreIds.add(String(s.store_id));
    });
  } else if (storeInfo?.store_id) {
    allowedStoreIds.add(String(storeInfo.store_id));
  }

  const isDesktop = useMediaQuery("(min-width: 900px)");

  const filteredOrders = last_order?.order_details?.filter((order) => {
    const orderStoreId = String(order?.store_details?.store_id || order?.store_id || "");
    if (!allowedStoreIds.has(orderStoreId)) return false;

    // In web view (desktop), hide FSR orders with a table_id
    if (isDesktop) {
      const hasTableId = Boolean(
        order?.store_details?.table_id ||
        order?.table_id ||
        order?.qr_table_id ||
        order?.store_details?.qr_table_id
      );
      if (hasTableId) return false;
    }

    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    
    const storeName = order?.store_details?.store_name || "";
    if (storeName.toLowerCase().includes(query)) return true;
    
    const hasMatchingItem = order?.item_details?.some(
      (item) => item?.item_name?.toLowerCase().includes(query)
    );
    if (hasMatchingItem) return true;
    
    return false;
  }) || [];

  if (isDesktop && selectedOrderDetail) {
    const activeColor = primaryColor || BUTTON_COLOR || "#E8450A";
    const selectedTender = selectedOrderDetail?.payment_details?.[0] || null;
    const recalculated = executeCalculationEngine(selectedOrderDetail, selectedTender, storeInfoConfig) || selectedOrderDetail;

    const rawOrderType = selectedOrderDetail?.order_type || selectedOrderDetail?.order_type_name || "Delivery";
    const orderNo = selectedOrderDetail?.invoice_no || selectedOrderDetail?.order_no || selectedOrderDetail?.orderNo || selectedOrderDetail?.offline_invoice_no || selectedOrderDetail?.order_id || (selectedOrderDetail?._id ? String(selectedOrderDetail._id).slice(-6) : "268");
    const isCompleted = (selectedOrderDetail?.order_status || selectedOrderDetail?.order_state || "").toUpperCase().includes("COMPLETE") || (selectedOrderDetail?.order_status || selectedOrderDetail?.order_state || "").toUpperCase().includes("CLOSE");

    const custAddrObj = selectedOrderDetail?.customer_details?.[0] || selectedOrderDetail?.customer_details || {};
    const orderCode = selectedOrderDetail?.order_code || selectedOrderDetail?.channel_code || "";
    const orderCodeStr = String(orderCode || rawOrderType || selectedOrderDetail?.order_type || "").toLowerCase();
    const isDineIn = orderCodeStr.includes("di") || orderCodeStr.includes("dine");
    const isTakeaway = orderCodeStr.includes("ta") || orderCodeStr.includes("take") || orderCodeStr.includes("pick");
    const isDeliveryOrder = (rawOrderType || "").trim().toLowerCase() === "delivery" || orderCodeStr.includes("del");
    const userDeliveryAddress = isDeliveryOrder ? (custAddrObj?.cust_address || "") : "";
    const addressType = custAddrObj?.address_type || "Home";

    const allItems = groupItems(recalculated?.item_details || selectedOrderDetail?.item_details || []);

    const formatCurrencyVal = (val) => {
      const num = parseFloat(val || 0);
      if (isNaN(num)) return "0";
      return num % 1 !== 0 ? num.toFixed(2) : num.toFixed(0);
    };

    let calculatedSubTotal = 0;
    allItems.forEach((item) => {
      const qty = parseInt(item?.quantity || item?.qty || 1, 10);
      const unitPrice = parseFloat(
        item?.regular_sales_unit_price ??
        item?.price ??
        item?.unit_price ??
        item?.item_price ??
        item?.selling_price ??
        item?.rate ??
        item?.plu ??
        item?.item_variant?.[0]?.plu ??
        item?.item_variant?.[0]?.regular_sales_unit_price ??
        0
      );
      let itemTotal = unitPrice * qty;
      if (itemTotal === 0 && (item?.extended_amount || item?.item_gross_sale || item?.sub_total || item?.total || item?.amount)) {
        itemTotal = parseFloat(item?.extended_amount || item?.item_gross_sale || item?.sub_total || item?.total || item?.amount || 0);
      }
      calculatedSubTotal += itemTotal;
    });

    const subTotalAmt = parseFloat(
      recalculated?.sub_total ??
      recalculated?.total_item_price ??
      recalculated?.total_net_sale ??
      selectedOrderDetail?.sub_total ??
      selectedOrderDetail?.total_item_price ??
      selectedOrderDetail?.total_net_sale ??
      calculatedSubTotal ??
      0
    );

    const discountAmt = parseFloat(
      recalculated?.total_discount ??
      recalculated?.discount ??
      selectedOrderDetail?.total_discount ??
      selectedOrderDetail?.discount ??
      0
    );

    const rawTax = parseFloat(
      recalculated?.total_item_tax ??
      recalculated?.total_tax ??
      selectedOrderDetail?.total_tax ??
      selectedOrderDetail?.total_item_tax ??
      selectedOrderDetail?.tax ??
      selectedOrderDetail?.tax_amount ??
      0
    );
    const rawCharges = parseFloat(
      recalculated?.additional_charges ??
      selectedOrderDetail?.additional_charges ??
      selectedOrderDetail?.store_charges ??
      0
    );
    const taxChargesAmt = rawTax + rawCharges;

    let exactPaidAmount = 0;
    if (selectedOrderDetail?.payment_details && Array.isArray(selectedOrderDetail.payment_details) && selectedOrderDetail.payment_details.length > 0) {
      exactPaidAmount = selectedOrderDetail.payment_details.reduce((sum, payment) => sum + parseFloat(payment.amount || 0), 0);
    }
    const finalGrandTotal = exactPaidAmount > 0 
      ? exactPaidAmount 
      : (recalculated?.rounded_total ?? recalculated?.transaction_grand_amount ?? selectedOrderDetail?.grand_total ?? selectedOrderDetail?.transaction_grand_amount ?? 0);

    let explicitRoundOff = parseFloat(
      selectedOrderDetail?.round_off_amount ??
      selectedOrderDetail?.round_off ??
      selectedOrderDetail?.round_off_details?.round_off_amount ??
      recalculated?.round_off_amount ??
      0
    );

    let computedDiff = finalGrandTotal - (subTotalAmt - discountAmt + taxChargesAmt);
    if (Math.abs(computedDiff) < 0.01) computedDiff = 0;

    const roundOffAmt = explicitRoundOff !== 0 ? explicitRoundOff : computedDiff;

    return (
      <div style={{ width: "100%", backgroundColor: "#ffffff", minHeight: "100vh" }}>
        {/* Top Bar: Back Arrow + Order Details */}
        <div
          style={{
            width: "100%",
            padding: "20px 32px",
            backgroundColor: "#ffffff",
            borderBottom: "1px solid #EAEAEA",
            display: "flex",
            alignItems: "center",
            gap: "16px",
            boxSizing: "border-box",
          }}
        >
          <div
            onClick={() => openOrderDetail(null)}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke={activeColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <Typography
            style={{
              fontFamily: "Satoshi, sans-serif",
              fontSize: "24px",
              fontWeight: "700",
              color: "#1A1A1A",
            }}
          >
            Order Details
          </Typography>
        </div>

        {/* Content Container */}
        <div style={{ width: "100%", padding: "32px 32px", boxSizing: "border-box" }}>
          {/* Top Status / Delivery Row */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "24px" }}>
            <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", maxWidth: "70%" }}>
              {isDineIn ? (
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    marginTop: "2px",
                    flexShrink: 0,
                    backgroundColor: activeColor,
                    WebkitMask: `url(${dineInIcon}) no-repeat center / contain`,
                    mask: `url(${dineInIcon}) no-repeat center / contain`,
                  }}
                />
              ) : isTakeaway ? (
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    marginTop: "2px",
                    flexShrink: 0,
                    backgroundColor: activeColor,
                    WebkitMask: `url(${takeAwayIcon}) no-repeat center / contain`,
                    mask: `url(${takeAwayIcon}) no-repeat center / contain`,
                  }}
                />
              ) : (
                <div style={{ width: "24px", height: "24px", marginTop: "2px", flexShrink: 0 }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 21C16 17.5 20 13.4183 20 9C20 4.58172 16.4183 1 12 1C7.58172 1 4 4.58172 4 9C4 13.4183 8 17.5 12 21Z" fill={activeColor}/>
                    <circle cx="12" cy="9" r="3" fill="#FFFFFF"/>
                  </svg>
                </div>
              )}
              <div style={{ textAlign: "left" }}>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "20px", fontWeight: "700", color: "#666666" }}>
                  {isDeliveryOrder ? `Delivered to ${addressType}` : `${rawOrderType}`}
                </Typography>
                {isDeliveryOrder && userDeliveryAddress && (
                  <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", color: "#666666", marginTop: "4px", lineHeight: "1.4" }}>
                    {userDeliveryAddress}
                  </Typography>
                )}
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: activeColor ? `${activeColor}1A` : "#FFF0EB",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: activeColor,
                    WebkitMask: `url(${BasketIcon}) no-repeat center / contain`,
                    mask: `url(${BasketIcon}) no-repeat center / contain`,
                  }}
                />
              </div>
              <div style={{ textAlign: "left" }}>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", fontWeight: "700", color: "#1A1A1A" }}>
                  {isCompleted
                    ? (rawOrderType || "").trim().toLowerCase() === "delivery"
                      ? "Order Delivered"
                      : "Order Completed"
                    : (selectedOrderDetail?.order_state || selectedOrderDetail?.order_status || "In Progress")}
                </Typography>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "13px", color: "#666666", marginTop: "2px" }}>
                  on {formatOrderDate(selectedOrderDetail?.date_time || selectedOrderDetail?.created_at)}
                </Typography>
              </div>
            </div>
          </div>

          {/* White Order Card */}
          <div style={{ backgroundColor: "#FFFFFF", borderRadius: "16px", border: "1px solid #CCCCCC", padding: "28px", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.03)", marginBottom: "28px" }}>
            {/* Header Sub-Row: Order # and Store Address vs Favourite & Download Invoice */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", paddingBottom: "20px", borderBottom: "1px solid #F2F2F7", marginBottom: "20px" }}>
              <div style={{ textAlign: "left" }}>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "20px", fontWeight: "700", color: "#1A1A1A" }}>
                  Order #{orderNo}
                </Typography>
                {isDeliveryOrder && userDeliveryAddress && (
                  <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", color: "#666666", marginTop: "4px", maxWidth: "600px", lineHeight: "1.4" }}>
                    {userDeliveryAddress}
                  </Typography>
                )}
              </div>

              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "12px" }}>
                <Button
                  variant="outlined"
                  style={{
                    borderColor: activeColor,
                    color: activeColor,
                    borderRadius: "3px",
                    textTransform: "none",
                    fontFamily: "Satoshi, sans-serif",
                    fontWeight: "700",
                    fontSize: "16px",
                    padding: "6px 16px",
                  }}
                >
                  Set as Favourite
                </Button>

                <div
                  onClick={() => download_invoice({ _id: selectedOrderDetail?._id, orderNo: orderNo })}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    color: activeColor,
                    fontSize: "16px",
                    fontWeight: "700",
                    fontFamily: "Satoshi, sans-serif",
                    cursor: "pointer",
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={activeColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"/>
                  </svg>
                  Download Invoice
                </div>
              </div>
            </div>

            {/* Qty & Item Name Table */}
            <div style={{ marginBottom: "24px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "12px", borderBottom: "1px solid #F2F2F7", marginBottom: "16px" }}>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", fontWeight: "600", color: "#666666" }}>
                  Qty & Item Name
                </Typography>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", fontWeight: "600", color: "#666666" }}>
                  Total
                </Typography>
              </div>

              {allItems.map((item, itemIdx) => {
                const qty = parseInt(item?.quantity || item?.qty || 1, 10);
                const unitPrice = parseFloat(
                  item?.regular_sales_unit_price ??
                  item?.price ??
                  item?.unit_price ??
                  item?.item_price ??
                  item?.selling_price ??
                  item?.rate ??
                  item?.plu ??
                  item?.item_variant?.[0]?.plu ??
                  item?.item_variant?.[0]?.regular_sales_unit_price ??
                  0
                );
                let itemTotal = unitPrice * qty;
                if (itemTotal === 0 && (item?.extended_amount || item?.item_gross_sale || item?.sub_total || item?.total || item?.amount)) {
                  itemTotal = parseFloat(item?.extended_amount || item?.item_gross_sale || item?.sub_total || item?.total || item?.amount || 0);
                }

                const modifiers = (item?.selected_modifier || item?.selectedModifier || []).flatMap((sm) => {
                  if (Array.isArray(sm?.modifiers)) {
                    return sm.modifiers.map((m) => m?.modifier_name || m?.name).filter(Boolean);
                  }
                  return [sm?.modifier_name || sm?.name].filter(Boolean);
                });
                const addonsList = item?.subItems?.length ? item.subItems : (item?.selectedAddonsItems || item?.selected_addons_items || []);
                const addons = addonsList.map((a) => a?.item_name || a?.name || a?.item_variant?.[0]?.item_name || "").filter(Boolean);
                const modifiersText = [...modifiers, ...addons]
                  .filter(Boolean)
                  .map((n) => n.trim())
                  .filter((n) => n !== "")
                  .join(", ");

                return (
                  <div key={itemIdx} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "8px 0" }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px", textAlign: "left" }}>
                      <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", fontWeight: "600", color: "#333333" }}>
                        {qty} X {item?.item_name || "Item"}
                      </Typography>
                      {modifiersText && (
                        <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "13px", color: "#666666", marginTop: "2px" }}>
                          {modifiersText}
                        </Typography>
                      )}
                    </div>
                    <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", fontWeight: "700", color: "#333333" }}>
                      {currency}{formatCurrencyVal(itemTotal)}
                    </Typography>
                  </div>
                );
              })}
            </div>

            {/* Subtotal / Charges Breakdown */}
            <div style={{ borderTop: "1px solid #F2F2F7", paddingTop: "16px", marginBottom: "20px", display: "flex", flexDirection: "column", gap: "10px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", color: "#333333" }}>
                  Sub Total
                </Typography>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", fontWeight: "600", color: "#333333" }}>
                  {currency}{formatCurrencyVal(subTotalAmt)}
                </Typography>
              </div>

              {discountAmt > 0 && (
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", color: "#333333" }}>
                    Discount
                  </Typography>
                  <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", fontWeight: "600", color: "#388E3C" }}>
                    -{currency}{formatCurrencyVal(discountAmt)}
                  </Typography>
                </div>
              )}

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", color: "#333333" }}>
                  Taxes & Charges
                </Typography>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", fontWeight: "600", color: "#333333" }}>
                  {currency}{formatCurrencyVal(taxChargesAmt)}
                </Typography>
              </div>

              {Math.abs(roundOffAmt) > 0.001 && (
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", color: "#333333" }}>
                    Round Off
                  </Typography>
                  <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", fontWeight: "600", color: "#1A1A1A" }}>
                    {roundOffAmt > 0 ? `+${currency}${formatCurrencyVal(roundOffAmt)}` : `-${currency}${formatCurrencyVal(Math.abs(roundOffAmt))}`}
                  </Typography>
                </div>
              )}
            </div>

            {/* Grand Total Row */}
            <div style={{ borderTop: "1px solid #EAEAEA", paddingTop: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", fontWeight: "700", color: "#1A1A1A" }}>
                Grand Total
              </Typography>
              <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "22px", fontWeight: "800", color: "#1A1A1A" }}>
                {currency}{formatCurrencyVal(finalGrandTotal)}
              </Typography>
            </div>
          </div>

          {/* Full-width Reorder / Status Button */}
          {isMenuOnly ? (
            <Button
              variant="contained"
              style={{
                width: "100%",
                height: "52px",
                backgroundColor: activeColor,
                color: "white",
                fontSize: "17px",
                fontWeight: "700",
                fontFamily: "Satoshi, sans-serif",
                borderRadius: "10px",
                textTransform: "none",
                boxShadow: "none",
                cursor: "default",
                pointerEvents: "none",
              }}
            >
              {isCompleted ? "Completed" : "Closed"}
            </Button>
          ) : (
            <Button
              onClick={() => handleReorderButton(selectedOrderDetail)}
              variant="contained"
              style={{
                width: "100%",
                height: "52px",
                backgroundColor: activeColor,
                color: "white",
                fontSize: "17px",
                fontWeight: "700",
                fontFamily: "Satoshi, sans-serif",
                borderRadius: "10px",
                textTransform: "none",
                boxShadow: "none",
              }}
            >
              Reorder
            </Button>
          )}
        </div>
      </div>
    );
  }

  if (isDesktop) {
    return (
      <div style={{ width: "100%", backgroundColor: "#FAFAFA", minHeight: "100vh" }}>
        {/* Header Bar: Back Arrow + My Orders */}
        <div
          style={{
            width: "100%",
            padding: "20px 32px",
            backgroundColor: "#ffffff",
            borderBottom: "1px solid #EAEAEA",
            display: "flex",
            alignItems: "center",
            gap: "16px",
            boxSizing: "border-box",
          }}
        >
          <div
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M20 12H4M4 12L10 6M4 12L10 18" stroke={primaryColor || BUTTON_COLOR || "#E8450A"} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <Typography
            style={{
              fontFamily: "Satoshi, sans-serif",
              fontSize: "24px",
              fontWeight: "700",
              color: "#1A1A1A",
            }}
          >
            My Orders
          </Typography>
        </div>

        {/* Desktop 4-Column Grid Container */}
        <div style={{ width: "100%", padding: "32px", boxSizing: "border-box" }}>
          {filteredOrders?.length >= 1 ? (
            <Grid container spacing={3}>
              {filteredOrders.map((ele, index) => {
                const activeColor = primaryColor || BUTTON_COLOR;
                const recalculated = executeCalculationEngine(ele, null, storeInfoConfig) || ele;

                const rawOrderType = ele?.order_type || ele?.order_type_name || "Delivery";
                const orderNo = ele?.invoice_no || ele?.order_no || ele?.orderNo || ele?.offline_invoice_no || ele?.order_id || (ele?._id ? String(ele._id).slice(-6) : "");
                const isCompleted = (ele?.order_status || ele?.order_state || "").toUpperCase().includes("COMPLETE") || (ele?.order_status || ele?.order_state || "").toUpperCase().includes("CLOSE");

                return (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <div
                      onClick={() => openOrderDetail(ele)}
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "7px",
                        border: "1px solid #EEEEEE",
                        boxShadow: "0px 0px 8.7px 0px #0000001F",
                        padding: "18px 20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        minHeight: "190px",
                        height: "100%",
                        boxSizing: "border-box",
                        cursor: "pointer",
                      }}
                    >
                      {/* Top Header: Order Type & Order # vs Status Pill / Reorder */}
                      <div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "10px" }}>
                          <div>
                            <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "16px", fontWeight: "700", color: "#1A1A1A", textAlign: "left" }}>
                              {rawOrderType}
                            </Typography>
                            <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "12px", color: "#8E8E93", textAlign: "left", marginTop: "2px" }}>
                              Order #{orderNo}
                            </Typography>
                          </div>

                          <div>
                            {getStatusActionArea(ele, primaryColor, secondaryColor, BUTTON_COLOR, TEXT_COLOR, handleReorderButton, storeInfoConfig)}
                          </div>
                        </div>

                        {/* Items List */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "10px" }}>
                          {(() => {
                            const showAll = !!expandedOrders[index];
                            const allItems = groupItems(ele?.item_details || []);
                            const displayedItems = showAll ? allItems : allItems.slice(0, 3);
                            const remainingCount = allItems.length - 3;

                            return (
                              <>
                                {displayedItems.map((item, itemIdx) => {
                                  const dietaryIcon = getDietaryIcon(item, itemVerriantList);
                                  const modifiers = (item?.selected_modifier || item?.selectedModifier || []).flatMap((sm) => {
                                    if (Array.isArray(sm?.modifiers)) {
                                      return sm.modifiers.map((m) => m?.modifier_name || m?.name).filter(Boolean);
                                    }
                                    return [sm?.modifier_name || sm?.name].filter(Boolean);
                                  });
                                  const addonsList = item?.subItems?.length ? item.subItems : (item?.selectedAddonsItems || item?.selected_addons_items || []);
                                  const addons = addonsList.map(a => a?.item_name || a?.name || a?.item_variant?.[0]?.item_name || "").filter(Boolean);
                                  const modifiersText = [...modifiers, ...addons].filter(Boolean).map(n => n.trim()).filter(n => n !== "").join(", ");

                                  return (
                                    <div key={itemIdx} style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        {dietaryIcon
                                          ? <img src={dietaryIcon} alt="dietary" style={{ width: "14px", height: "14px", flexShrink: 0 }} />
                                          : <span style={{ display: "inline-block", width: "14px", height: "14px", flexShrink: 0 }} />
                                        }
                                        <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", fontWeight: "700", color: "#1A1A1A", textAlign: "left" }}>
                                          {item?.quantity || 1} X {item?.item_name || "Item"}
                                        </span>
                                      </div>
                                      {modifiersText && (
                                        <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "11px", color: "#777777", paddingLeft: "20px", textAlign: "left", lineHeight: "1.3" }}>
                                          {modifiersText}
                                        </span>
                                      )}
                                    </div>
                                  );
                                })}
                                {allItems.length > 3 && (
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setExpandedOrders(prev => ({ ...prev, [index]: !prev[index] }));
                                    }}
                                    style={{
                                      fontFamily: "Satoshi, sans-serif",
                                      fontWeight: "700",
                                      fontSize: "12px",
                                      color: activeColor,
                                      cursor: "pointer",
                                      paddingLeft: "20px",
                                      textAlign: "left",
                                      marginTop: "2px",
                                    }}
                                  >
                                    {showAll ? "Show less" : `& ${remainingCount} more items`}
                                  </span>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </div>

                      {/* Card Footer: Date, Status Text & Price */}
                      <div style={{ borderTop: "1px solid #F2F2F7", paddingTop: "12px", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "2px" }}>
                          <span style={{ fontSize: "11px", fontFamily: "Satoshi, sans-serif", color: "rgba(51, 51, 51, 1)", textAlign: "left" }}>
                            Order Placed on {formatOrderDate(ele?.date_time || ele?.created_at)}
                          </span>
                          <span style={{
                            fontSize: "12px",
                            fontWeight: "700",
                            fontFamily: "Satoshi, sans-serif",
                            color: (ele?.order_status || "").toUpperCase() === "CANCELLED" ? "#EF4444" : activeColor,
                            textAlign: "left",
                          }}>
                            {isCompleted ? "Completed" : (ele?.order_state || ele?.order_status || "In Progress")}
                          </span>
                        </div>

                        <span style={{ fontSize: "18px", fontWeight: "800", fontFamily: "Satoshi, sans-serif", color: "#1A1A1A" }}>
                          {(() => {
                            let exactPaidAmount = 0;
                            if (ele?.payment_details && Array.isArray(ele.payment_details) && ele.payment_details.length > 0) {
                              exactPaidAmount = ele.payment_details.reduce((sum, payment) => sum + parseFloat(payment.amount || 0), 0);
                            }
                            const finalAmountToDisplay = exactPaidAmount > 0 
                              ? exactPaidAmount 
                              : (recalculated?.rounded_total ?? recalculated?.transaction_grand_amount ?? 0);
                            
                            return `${currency}${finalAmountToDisplay.toFixed(0)}`;
                          })()}
                        </span>
                      </div>
                    </div>
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <div style={{ textAlign: "center", padding: "60px 0" }}>
              <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", color: "#777777" }}>
                No orders found
              </Typography>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%", backgroundColor:"white" }}>
      {filteredOrders?.length >= 1 ? (
        <div style={{
          width: "100%",
          padding: "16px",
          maxHeight: "calc(100vh - 190px)",
          overflowY: "auto",
          scrollbarWidth: "none",
        }}>
          {filteredOrders.map((ele, index) => {
            const store_id = ele?.store_details?.store_id || ele?.store_id;
            const targetStore = stores?.find((s) => s.store_id === store_id);
            const logo = targetStore?.store_logo || targetStore?.store_display_logo ||defaultimg;
            
            const activeColor = primaryColor || BUTTON_COLOR;
            const recalculated = executeCalculationEngine(ele, null, storeInfoConfig) || ele;
            
            return (
              <div
                key={index}
                onClick={() => openOrderDetail(ele)}
                style={{
                  backgroundColor: "white",
                  borderRadius: "7px",
                  padding: "16px",
                  marginBottom: "16px",
                  boxShadow: "0px 0px 8.7px 0px #0000001F",
                  border: "1px solid #EEEEEE",
                  cursor: "pointer",
                }}
              >
                {/* Header Row: Store Logo, Store Name, View Menu link, Status Button */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <img
                      src={logo}
                      alt="Store Logo"
                      onError={(err) => {
                        err.target.onerror = null;
                        err.target.src = defaultimg;
                      }}
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "1px solid #EDF2F7",
                        flexShrink: 0,
                      }}
                    />
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                      <span style={{ fontSize: "16px", fontWeight: "700", fontFamily: "Satoshi", color: "#2D3748" }}>
                        {
                          ele?.store_details?.store_name || 
                          stores?.find(s => String(s.store_id) === String(ele?.store_details?.store_id || ele?.store_id))?.store_name || 
                          storeInfo?.store_name || 
                          "Store"
                        }
                      </span>
                      <span
                        onClick={() => handleViewMenu(ele)}
                        style={{
                          fontSize: "12px",
                          fontWeight: "500",
                          fontFamily: "Satoshi",
                          color: activeColor,
                          textDecoration: "underline",
                          cursor: "pointer",
                          marginTop: "2px",
                        }}
                      >
                        View menu
                      </span>
                    </div>
                  </div>
                  
                  <div>
                    {getStatusActionArea(ele, primaryColor, secondaryColor, BUTTON_COLOR, TEXT_COLOR, handleReorderButton, storeInfoConfig)}
                  </div>
                </div>
                
                {/* <Divider style={{ backgroundColor: "#EDF2F7" }} /> */}
                
                {/* Items List */}
                <div style={{ padding: "8px 0" }}>
                  {(() => {
                    const showAll = !!expandedOrders[index];
                    const allItems = groupItems(ele?.item_details || []);
                    const displayedItems = showAll ? allItems : allItems.slice(0, 3);
                    const remainingCount = allItems.length - 3;

                    return (
                      <>
                        {displayedItems.map((item, itemIdx) => {
                          const dietaryIcon = getDietaryIcon(item, itemVerriantList);
                          const modifiers = (item?.selected_modifier || item?.selectedModifier || []).flatMap((sm) => {
                            if (Array.isArray(sm?.modifiers)) {
                              return sm.modifiers.map((m) => m?.modifier_name || m?.name).filter(Boolean);
                            }
                            return [sm?.modifier_name || sm?.name].filter(Boolean);
                          });
                          const addonsList2 = item?.subItems?.length ? item.subItems : (item?.selectedAddonsItems || item?.selected_addons_items || []);
                          const addons = addonsList2.map(a => a?.item_name || a?.name || a?.item_variant?.[0]?.item_name || "").filter(Boolean);
                          const modifiersText = [...modifiers, ...addons].filter(Boolean).map(n => n.trim()).filter(n => n !== "").join(", ");

                          return (
                            <div key={itemIdx} style={{ display: "flex", flexDirection: "column", padding: "4px 0" }}>
                              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                {dietaryIcon ? (
                                  <img src={dietaryIcon} alt="dietary" style={{ width: "16px", height: "16px" }} />
                                ) : (
                                  <div style={{ width: "16px", height: "16px" }} />
                                )}
                                <span style={{ fontSize: "15px", fontWeight: "600", fontFamily: "Satoshi", color: "#2D3748", textAlign: "left" }}>
                                  {item?.quantity || 1} X {item?.item_name || "NA"}
                                </span>
                              </div>
                              {modifiersText && (
                                <div style={{
                                  fontSize: "12px",
                                  fontFamily: "Satoshi",
                                  color: "#718096",
                                  paddingLeft: "26px",
                                  marginTop: "2px",
                                  textAlign: "left",
                                }}>
                                  {modifiersText}
                                </div>
                              )}
                            </div>
                          );
                        })}
                        {allItems.length > 3 && (
                          <div style={{ marginTop: "8px", paddingLeft: "26px", display: "flex", justifyContent: "flex-start" }}>
                            <span
                              onClick={(e) => {
                                e.stopPropagation();
                                setExpandedOrders(prev => ({ ...prev, [index]: !prev[index] }));
                              }}
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "700",
                                fontSize: "14px",
                                color: primaryColor || BUTTON_COLOR,
                                cursor: "pointer",
                                textDecoration: "underline",
                              }}
                            >
                              {showAll ? "Show less" : `& ${remainingCount} more items`}
                            </span>
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
                
                <Divider style={{ backgroundColor: "#EDF2F7" }} />
                
                {/* Footer: Date, Status Text, Price */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "12px" }}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                    <span style={{ fontSize: "12px", fontFamily: "Satoshi", color: "rgba(51, 51, 51, 1)", textAlign: "left" }}>
                      Order Placed on {formatOrderDate(ele?.date_time || ele?.created_at)}
                    </span>
                    <span style={{
                      fontSize: "13px",
                      fontWeight: "700",
                      fontFamily: "Satoshi",
                      color: (ele?.order_status || "").toUpperCase() === "CANCELLED" ? "#EF4444" : activeColor,
                      textAlign: "left",
                    }}>
                      {(ele?.order_state || ele?.order_status || "In Progress")}
                    </span>
                  </div>
                  
                  <span style={{ fontSize: "18px", fontWeight: "800", fontFamily: "Satoshi", color: activeColor }}>
                    {(() => {
                      let exactPaidAmount = 0;
                      if (ele?.payment_details && Array.isArray(ele.payment_details) && ele.payment_details.length > 0) {
                        exactPaidAmount = ele.payment_details.reduce((sum, payment) => sum + parseFloat(payment.amount || 0), 0);
                      }
                      const finalAmountToDisplay = exactPaidAmount > 0 
                        ? exactPaidAmount 
                        : (recalculated?.rounded_total ?? recalculated?.transaction_grand_amount ?? 0);
                      
                      return (
                        <>
                          <span style={{ fontWeight: "600",fontSize: "18px" }}>{currency}{" "}</span>
                          {finalAmountToDisplay.toFixed(2)}
                        </>
                      );
                    })()}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ padding: "40px", textAlign: "center", width: "100%" }}>
          <Typography style={{ marginTop: "3rem" }}>
            <span style={{ fontFamily: "Satoshi", fontWeight: "600", color: "#718096" }}>No Recent Order</span>
          </Typography>
          <Typography
            style={{ marginTop: "2rem", cursor: "pointer", color: primaryColor || BUTTON_COLOR }}
            onClick={() => navigate("/menu")}
          >
            <b style={{ fontFamily: "Satoshi" }}>Back to menu</b>
          </Typography>
        </div>
      )}
      <Dialog
        open={confirmPopup}
        onClose={() => setConfirmPopup(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "20px",
            padding: "20px",
            backgroundColor: "#fff",
          },
        }}
      >
        <DialogTitle
          style={{
            padding: "0px",
            marginBottom: "10px",
          }}
        >
          <Typography
            style={{
              fontFamily: "Plus Jakarta Sans",
              fontSize: "30px",
              color: primaryColor || "#000",
              fontWeight: "700",
              textAlign: "center",
            }}
          >
           <span style={{fontSize:"20px"}}>Switch Outlet?</span> 
          </Typography>
        </DialogTitle>

        <DialogContent style={{ padding: "0px", marginBottom: "20px" }}>
          <Typography
            style={{
              fontFamily: "Satoshi",
              fontSize: "14px",
              color: "#333333",
              textAlign: "left",
              fontWeight: "500",
            }}
          >
            Switching to {pendingOrder?.store_details?.store_name || pendingOrder?.store_name} will clear your cart.
            Do you wish to proceed?
          </Typography>
        </DialogContent>

        <DialogActions style={{ padding: "0px", justifyContent: "flex-start", gap: "10px" }}>
          <MuiButton
            onClick={() => setConfirmPopup(false)}
            variant="contained"
            disableElevation
            style={{
              flex: "1",
              borderRadius: "8px",
              fontSize: "14px",
              border: `1px solid ${primaryColor || "#000"}`,
              color: primaryColor || "#000",
              background:  "white"  || "#fff",
              textTransform: "none",
              fontWeight: "600",
              padding: "8px",
              boxShadow: "none",
            }}
          >
            Cancel
          </MuiButton>

          <MuiButton
            onClick={confirmReorderSwitch}
            variant="contained"
            disableElevation
            style={{
              flex: "1",
              borderRadius: "8px",
              fontSize: "14px",
              color:  "white"  || "#fff",
              backgroundColor: primaryColor || "#000",
              textTransform: "none",
              fontWeight: "700",
              padding: "8px",
              boxShadow: "none",
            }}
          >
            Proceed
          </MuiButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
